import Axios from "axios";
import JwtService from "../auth/services/jwtService";

// Use environment variable or fallback to relative API path for Docker setup
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "/api";

const axios = Axios.create({ 
  baseURL: BASE_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

const authRequestInterceptor = async (config: any) => {
  config.headers = { ...config.headers };
  config.headers.Accept = "application/json";

  // Retrieve tokens from localStorage or any secure storage mechanism
  const accessToken = JwtService.getAccessToken();
  const refreshToken = JwtService.getRefreshToken();

  // Set the Authorization header if accessToken exists
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  // Optionally, send refresh token in headers if needed
  if (refreshToken) {
    config.headers["refresh-token"] = refreshToken;
  }

  return config;
};

// Attach the interceptor
axios.interceptors.request.use(authRequestInterceptor);

export default axios;